<template>
  <section class="content">
  <h3>Table of Contents</h3>
    <ol class="roman">
      <li><router-link to="/introduction">Introduction</router-link></li>
      <li><router-link to="/cv">Curriculum vitae</router-link></li>
      <li>
        Teaching Portfolio
        <ol class="letters">
          <li><router-link to="/teaching-statement"
          >Statement of Teaching Philosophy and Priorities</router-link></li>
          <li>Sample teaching materials
            <ol class="sections">
              <li><router-link to="/syllabi-etc"
              >Syllabi and Rehearsal Plans</router-link></li>
              <li><router-link to="/handouts">Handouts &amp; Assignments</router-link></li>
              <li><router-link to="/recordings">Concert Recordings</router-link></li>
              <li><router-link to="/programs">Concert Programs</router-link></li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        Scholarly and Artistic Portfolio
        <ol class="letters">
          <li>
            <router-link to="/scholarship-statement"
            >Statement of Scholarly and Artistic Priorities</router-link>
          </li>
          <li>Supporting documents
            <ol class="sections">
              <li><router-link to="/external-programs">Programs</router-link></li>
              <li><router-link to="/workshops">Workshop Handouts</router-link></li>
              <li><router-link to="/publications">Publications</router-link></li>
              <li><router-link to="/other-docs">Other</router-link></li>
            </ol>
          </li>
        </ol>
      </li>
      <li>
        Service Portfolio
        <ol class="letters">
          <li>
            <router-link to="/service-statement">Statement of Service Priorities</router-link>
          </li>
        </ol>
      </li>
    </ol>
  </section>
</template>

<script>
export default {
  name: 'About',
  data() {
    return {
      msg: 'Welcome to Crypto Info',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  ol.roman {
    list-style-type: upper-roman;
  }

  ol.roman li {
    margin-bottom: 18px;
  }

  ol.letters {
    list-style-type: lower-alpha;
  }

  ol.letters li {
    margin-top: 10px;
    /* margin-bottom: 5px; */
  }

  ol.sections {
    list-style-type: decimal;
  }

  ol.sections li {
    margin-bottom: 0px;
    margin-top: 0px;
  }

  ol.sections li::before {
    display: inline-block;
    content: "§";
    transform: translateX(-25px);
  }

</style>



// WEBPACK FOOTER //
// src/components/Contents.vue